import React, { useCallback, useEffect } from 'react'
import { useParams, RouteChildrenProps } from 'react-router-dom'
import useAPIRequest from '../../../../hooks/useAPIRequest'
import API from '../../../../services/api'
import ParticipantForm from './ParticipantForm'
import LoadingSpinner from '../../../atoms/loadingspinner/LoadingSpinner'
import Banner from '../../../atoms/banner/Banner'
import Container from '../../../atoms/page/Page'

function EditParticipant(props: RouteChildrenProps) {
  const { eventId, participantId } = useParams<{ eventId: string, participantId: string }>()

  const callback = useCallback(async () => {
    const event = await API.getEvent(eventId)
    return {
      event,
      participant: event.participants.find(p => p.id === participantId)
    }
  }, [eventId, participantId])

  const [{ inProgress, data, error}, doApiRequest] = useAPIRequest(callback, null)

  useEffect(() => {
    doApiRequest()
  }, [doApiRequest])

  if (data && !data.event.participants.find(p => p.id === participantId)) {
    return <Container>
      <Banner type='error' active message={`A participant with the id ${participantId} was not found`} />
    </Container>
  }

  return (
    <Container>
      {inProgress && <LoadingSpinner />}
      {error && <Banner type='error' active={!!error} message={error?.message} />}
      {!inProgress && data && <ParticipantForm event={data.event} participant={data.participant} {...props} />}
    </Container>
  )
}

export default EditParticipant
